import { ICustomer } from "src/core/customers/api/customers.api";

/**
 * Function for formatting a customer name
 * e.g: customerName (customer.accountNumber)
 * @param customer - customer object
 * @returns formatted customer name
 */
export const formatCustomerName = (customer: Pick<ICustomer, "accountNumber" | "name">, reverse = false): string => {
  let formattedCustomer = "";

  if (customer) {
    if (reverse) {
      if (customer.accountNumber) {
        formattedCustomer += ` (${customer.accountNumber})`;
      }

      if (customer.name) {
        formattedCustomer += ` ${customer.name}`;
      }
    } else {
      if (customer.name) {
        formattedCustomer += ` ${customer.name}`;
      }

      if (customer.accountNumber) {
        formattedCustomer += ` (${customer.accountNumber})`;
      }
    }
  }

  return formattedCustomer;
};